import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { AuthProvider } from './context/AuthContext';
import routes from './routes';

const App = () => {
  return (
    <HelmetProvider>
      <Router>
        <AuthProvider>
          <Routes>
            {routes.map(({ path, element, title }) => (
              <Route 
                key={path}
                path={path}
                element={element}
              />
            ))}
          </Routes>
        </AuthProvider>
      </Router>
    </HelmetProvider>
  );
};

export default App;